module.exports = __webpack_public_path__ + "static/media/Renovation-Immobilier-Vaud-1.a01fc71d.jpg";